import { C } from "../../shared/theme";
import { hue } from "../../shared/hue";
import { KindIcon } from "../../shared/kindIcons";
import { MarkedLine, GoalDot, MARKED_INDENT } from "../../shared/MarkedLine";
import { dueWords } from "../../shared/deadlines";
import { DoneCheck } from "./DoneCheck";
import { AddToTodayButton } from "../today/AddToTodayButton";

// One unfinished task on Tasks, Goals, Radar, Key Dates, the Dreamboard and Fears, as a card like Today's (Craig, 27 Oct 2026: "it's
// becoming a wall of text … borrow some of the design elements from the task display on the Today page"): a circle to
// mark it done, its words, a line with its goal (when `goal` is given), a line with its deadline and an optional `note`
// ({ text, color }), then `links` (from useTaskLinksOf), one a line: its Key Date, dream and fear, each after its kind's
// icon in its hue, with the kind read aloud instead of shown (MarkedLine). The deadline line lines up with the names
// when there are any, one size up from them (Craig, 29 Oct 2026: "I think it should maybe be larger"): it's the fact a
// user acts on. The circle sits 10px in from the card's edge (Craig: "add a bit of padding between the task row border
// and the done circle"). `done` greys it out while the tick saves. Tapping the words
// opens the task. `showDue={false}` leaves out the deadline where the list's heading already says it (Radar's Tasks Due
// Today). onDone(task) saves the tick and returns a promise. onAddToday(task) puts it in today. `handle` is a ⠿ to drag
// the card, last on the right (a goal's page in its Manual order).
// "Due in 1 day · Oct 31" breaks only after the dot on a narrow card, never inside the date or before the dot.
const keepTogether = (text) => {
  const dot = text.indexOf(" · ");
  return dot < 0 ? text : `${text.slice(0, dot)}\u00a0· ${text.slice(dot + 3).replace(/ /g, "\u00a0")}`;
};

export function TaskListRow({ task, goal = null, note = null, links = [], done = false, showDue = true, onDone, onOpen, onAddToday, handle = null }) {
  const due = showDue ? dueWords(task.deadline) : null;
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 2, margin: "0 0 8px", padding: "2px 4px 2px 10px", background: C.surface, border: `1px solid ${C.border}`, borderRadius: C.rsm, opacity: done ? 0.35 : 1, transition: "opacity 0.2s" }}>
      <DoneCheck text={task.text} done={done} onDone={() => onDone(task)} />
      <button onClick={() => onOpen(task)}
        style={{ flex: 1, minWidth: 0, minHeight: 44, padding: "10px 0", background: "none", border: "none", textAlign: "left", cursor: "pointer", fontFamily: "inherit" }}>
        <span style={{ display: "block", fontSize: 17, color: C.text, lineHeight: 1.35 }}>{task.text}</span>
        {goal && <MarkedLine marker={<GoalDot goal={goal} />} label="Goal">{goal.title}</MarkedLine>}
        {(due || note) && (
          <MarkedLine style={{ paddingLeft: goal || links.length ? MARKED_INDENT : 0, fontSize: 15, fontWeight: 600 }}>
            {due && <span style={{ color: due.overdue ? C.red : C.textMid }}>{keepTogether(due.text)}</span>}
            {due && note && " "}
            {note && <span style={{ color: note.color || C.textMid }}>{note.text}</span>}
          </MarkedLine>
        )}
        {links.map(link => (
          <MarkedLine key={link.kind} marker={<KindIcon id={link.icon} size={15} color={hue(link.hueName).c} />} label={link.kind}>{link.name}</MarkedLine>
        ))}
      </button>
      <AddToTodayButton task={task} onAdd={onAddToday} style={task.todayPhase ? { alignSelf: "center", margin: "0 4px 0 8px" } : { alignSelf: "center" }} />
      {handle && <span style={{ alignSelf: "center", display: "flex" }}>{handle}</span>}
    </div>
  );
}
